import { getTaxesTextPair } from './chunk-PLRTMS2D.mjs';
import { menuSubcategoryCardFactory } from './chunk-QODWPB46.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuSubcategoriesTableFactory.ts
var menuSubcategoriesTableFactoryCore = (subcategories, categories, taxes) => {
  return Object.values(subcategories).map((subcategory) => {
    const subcategoryCoreCard = menuSubcategoryCardFactory({
      [subcategory.subcategoryId]: subcategory
    })[0];
    return __spreadProps(__spreadValues({}, subcategoryCoreCard), {
      comboCount: subcategory.comboIds.length,
      category: subcategory.categoryId ? categories[subcategory.categoryId].name : void 0,
      customizer: subcategory.customizer,
      taxes: getTaxesTextPair(subcategory.taxIds, taxes)
    });
  });
};

export { menuSubcategoriesTableFactoryCore };
